import { useState } from 'react';
import { Input, Space, Table, Typography, notification } from 'antd';
import { useTranslation } from 'react-i18next';
import PageContainer from '../../common/components/PageContainer';
import EmailBodyModal from './EmailBodyModal';
import { emailLogColumns } from './emailLogColumns';
import { EMAIL_LOG_PAGE_SIZE, useEmailLog } from './useEmailLog';

/** Super Admin log of every email the API sent: recipient, subject, template, outcome, time and body. */
export default function EmailLog() {
    const { t } = useTranslation('emailLog');
    const [api, contextHolder] = notification.useNotification();
    const [viewingId, setViewingId] = useState(null);
    // an empty table would read as "no emails were sent": say the log could not be loaded instead
    const { data, loading, page, setPage, search, sort, sortBy } = useEmailLog(() =>
        api.error({ message: t('loadFailed'), placement: 'top' })
    );

    // antd reports paging through the pagination's onChange, so only a sort change is handled here
    const onTableChange = (_pagination, _filters, sorter, { action }) => {
        if (action !== 'sort') return;
        if (!sorter.order) {
            sortBy(null);
            return;
        }
        sortBy({ field: sorter.columnKey, order: sorter.order === 'ascend' ? 'ASC' : 'DESC' });
    };

    return (
        <PageContainer>
            {contextHolder}
            <Typography.Title level={3}>{t('title')}</Typography.Title>
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                <Input.Search
                    allowClear
                    maxLength={320}
                    placeholder={t('searchPlaceholder')}
                    onSearch={search}
                    style={{ maxWidth: 360 }}
                />
                <Table
                    rowKey="id"
                    size="middle"
                    loading={loading}
                    columns={emailLogColumns(t, setViewingId, sort)}
                    dataSource={data.items}
                    onChange={onTableChange}
                    scroll={{ x: 'max-content' }}
                    pagination={{
                        current: page,
                        pageSize: EMAIL_LOG_PAGE_SIZE,
                        total: data.total,
                        onChange: setPage,
                        showSizeChanger: false,
                    }}
                />
            </Space>
            <EmailBodyModal emailId={viewingId} onClose={() => setViewingId(null)} />
        </PageContainer>
    );
}
